import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    scheduleGetPaged,
    scheduleActivate,
    scheduleDeactivate,
    scheduleDelete,
    requestScheduleExport,
    schedulePatch,
    methodPatchScheduling,
    methodAddService,
    methodGetScheduleEmails,
    methodHighlightSchedule,
    methodGetServiceConfirmation,
    methodPostServiceConfirmation,
    methodPutServiceConfirmation,
    methodDeleteServiceConfirmation, scheduleGetMapView,
    scheduleToggleAutoTravelExclusion
} from "api/menu/schedule/requests";

export const FETCH_SCHEDULE_SUCCESS = "FETCH_SCHEDULE_SUCCESS";
export const CLEAR_SCHEDULE_SUCCESS = "CLEAR_SCHEDULE_SUCCESS";
export const FETCH_MAP_VIEW_SUCCESS = "FETCH_MAP_VIEW_SUCCESS";
export const FETCH_SCHEDULE_REQUEST_LOADING = "FETCH_SCHEDULE_REQUEST_LOADING";
export const FETCH_SCHEDULE_REQUEST_ERRORS = "FETCH_SCHEDULE_REQUEST_ERRORS";

export const setLoading = () => ({
    type: FETCH_SCHEDULE_REQUEST_LOADING
});

export const fetchScheduleListPaged =
    (requestParams) => dispatch => {
    dispatch(setLoading());
    scheduleGetPaged(requestParams)
        .then(response => {
            dispatch({
                type: FETCH_SCHEDULE_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const fetchMapView =
    (requestParams) => dispatch => {
    dispatch(setLoading());
    scheduleGetMapView(requestParams)
        .then(response => {
            dispatch({
                type: FETCH_MAP_VIEW_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const clearScheduleList = () => dispatch => {
    dispatch({
        type: CLEAR_SCHEDULE_SUCCESS,
    });
};

export const setScheduleActivate = (filter, serviceId) => dispatch => {
    scheduleActivate(filter, serviceId)
        .then(response => {
            toast("Schedules(s) activated", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch({
                type: FETCH_SCHEDULE_SUCCESS,
                payload: response.data
            });
            // callback(true);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const setScheduleDeactivate = (filter, serviceId) => dispatch => {
    scheduleDeactivate(filter, serviceId)
        .then(response => {
            toast("Schedule(s) deactivated", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch({
                type: FETCH_SCHEDULE_SUCCESS,
                payload: response.data
            });
            // callback(true);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const scheduleExport = (filter, callback) => dispatch => {
    requestScheduleExport(filter)
        .then(response => {
            toast("Schedules exported", {
                type: toast.TYPE.SUCCESS,
            });
            callback(response.data);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const deleteScheduleActivate = (requestParams, callback) => dispatch => {
    scheduleDelete(requestParams)
        .then(() => {
            toast("Schedule(s) has been successfully deleted", {
                type: toast.TYPE.SUCCESS,
            });
            callback(true);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const requestPatchSchedule =
    (filter, data, callback = false) => dispatch => {
    schedulePatch(filter, data)
        .then(() => {
            // toast(`${response.data.affectedRecords} rows has been successfully updated`, {
            toast("Data successfully updated", {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback(true);
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const requestPatchScheduling =
    (serviceId, data, callback) => dispatch => {
        methodPatchScheduling(serviceId, data)
            .then(() => {
                callback();
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
            });
};

export const requestHighlightSchedule =
    (requestParams, callback) => dispatch => {
        methodHighlightSchedule(requestParams)
            .then(() => {
                toast("Schedule(s) has been successfully highlighted", {
                    type: toast.TYPE.SUCCESS,
                });
                callback(true);
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
            });
};

export const requestAddService =
    (data, callback) => dispatch => {
        dispatch(setLoading(true));
        methodAddService(data)
            .then(() => {
                dispatch(setLoading(false));
                callback(true);
            })
            .catch(error => {
                dispatch(setLoading(false));
                dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
            });
};

export const requestGetScheduleEmails = (requestData, callback) => dispatch => {
    methodGetScheduleEmails(requestData)
        .then((response) => {
            callback(response.data);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
        });
};

export const requestGetServiceConfirmation = (serviceId, callback = false) => {
    methodGetServiceConfirmation(serviceId)
        .then(response => {
            callback(response);
        })
        .catch(() => {
            callback(false);
        });
};

export const requestPostServiceConfirmation = (serviceId, data, callback) => dispatch => {
    methodPostServiceConfirmation(serviceId, data)
        .then(response => {
            if (data.estimatedDate) {
                toast("The service was successfully confirmed with specific date", {
                    type: toast.TYPE.SUCCESS,
                });
            } else {
                toast("The service was successfully confirmed but the date was not specified", {
                    type: toast.TYPE.SUCCESS,
                });
            }
            callback(response);
        })
        .catch(() => {
            toast("Error occures while confirming serice", {
                type: toast.TYPE.ERROR,
            });
            callback(false);
        });
};

export const requestPutServiceConfirmation = (serviceId, data, callback) => dispatch => {
    methodPutServiceConfirmation(serviceId, data)
        .then(response => {
            if (data.estimatedDate) {
                toast("The service was successfully confirmed with specific date", {
                    type: toast.TYPE.SUCCESS,
                });
            } else {
                toast("The service was successfully confirmed but the date was not specified", {
                    type: toast.TYPE.SUCCESS,
                });
            }
            callback(response);
        })
        .catch(() => {
            toast("Error occures while confirming serice", {
                type: toast.TYPE.ERROR,
            });
            callback(false);
        });
};

export const requestDeleteServiceConfirmation = (serviceId, callback) => dispatch => {
    methodDeleteServiceConfirmation(serviceId)
        .then(response => {
            toast("The service confirmation was successfully deleted.", {
                type: toast.TYPE.SUCCESS,
            });
            callback(response);
        })
        .catch(() => {
            toast("Error occurs while deleting service confirmation", {
                type: toast.TYPE.ERROR,
            });
            callback(false);
        });
};

export const requestToggleAutoTravelExclusion = (serviceId, exclude, callback) => dispatch => {
    scheduleToggleAutoTravelExclusion(serviceId, exclude)
        .then(() => {
            const message = exclude
                ? "Service excluded from automatic travel charges"
                : "Service included in automatic travel charges";

            toast(message, {
                type: toast.TYPE.SUCCESS,
            });
            callback(true);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SCHEDULE_REQUEST_ERRORS));
            callback(false);
        });
};
